<template>
<transition name="fade">
  <div class="tfooter" v-show="showFixFooter">
    <!-- <div class="up-virtrual"></div> -->
    <div class="up">
      <div class="infos" v-for="(item, index) in infos" :key="index">
        <span class="geekbang-icon" v-html="item.icon"></span>
        <div class="info">{{item.word}}</div>
      </div>
    </div>
    <!-- <div class="down">© 2017 Geekbang Technology Ltd. All rights reserved.</div> -->
  </div>
</transition>
</template>
<script>
import bus from '@/util/vueBus'
export default {
  data () {
    return {
      showFixFooter: false
    }
  },
  props: ['infos'],
  computed: {
    // isFixed () {
    //   return this.showFixFooter && window.scrollY < document.body.style.height - 40
    // }
  },
  created () {
    bus.$on('showFixFooter', (value) => {
      this.showFixFooter = value
    })
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

.fade-enter-active, .fade-leave-active
  transition: opacity 0.3s
.fade-enter, .fade-leave-to
  opacity: 0

.tfooter
  padding-top: 60px
  .up-virtrual
    height: 60px
  .up
    height: 60px
    background-color: #242628
    display: flex
    justify-content: center
    align-items: center
    color: #f5f5f5
    font-size: 18px
    position: fixed
    z-index: 100
    bottom: 0
    width: 100%
    +mobile
      height: 80px
      flex-direction: column
      align-items: left
      padding-left: 25px
    .infos
      display: flex
      +mobile
        font-size: 12px
        text-align: center
      .geekbang-icon
        font-size: 20px
        +mobile
          font-size: 12px
      .info
        padding-right: 50px
        padding-left: 10px
        +mobile
          margin: 1px 0
  .down
    height: 40px
    background-color: #1c1d1f
    color: #888
    display: flex
    justify-content: center
    align-items: center
    font-size: 12px
</style>
